import React, { useState, useEffect } from "react";
import { GetUserFullName } from "helpers";
import { useSelector, useDispatch } from "react-redux";
import { TE, httpStatusEnum } from "appconstants";
import { GridTable } from "@ctsu/ctsu-mui-grid";
import { saveCohortArmData } from "actions/protocols/protocoldetail";
import { withAppContext } from "@ctsu/loader";
import { bindLogger } from "helpers/BindLogger";
import { openSnackbar } from "helpers/Notifier";
import { bindActionCreators } from "redux";
import { CanUserEditArmCohorts, CanUserAddArmCohorts } from "appconstants/Permission";
import { CohortsArmManagementColumns } from "../gridcolumns";
import EditArmCohort from "./EditCohortArmManagement";

import { useCanEditProtocol, useEditableCohortFields } from "./Arms/userRoleHooks";

const CohortsArmGrid = (props) => {
  const {
    loadStatusRecords,
    highlightObj,
    onLoad,
    rowClick,
    setHighlighted,
    loadHistory,
    onOpenModal,
    context
  } = props;

  const cohortData = useSelector((state) => state.prtDetails.cohortsArmData);
  const prtInfo = useSelector((state) => state.prtDetails.prtInfo);
  const dispatch = useDispatch();

  const action = bindActionCreators({ saveCohortArmData }, dispatch);
  const hasEditPermission = CanUserEditArmCohorts();
  const hasAddPermission = CanUserAddArmCohorts();
  const candEditThisProtocol = useCanEditProtocol(prtInfo?.leadGrp)
  const canEditCohort = hasEditPermission && candEditThisProtocol ;
  const canAddArmsCohort = hasAddPermission && candEditThisProtocol;
  const [accuralTargetSumActive, setActiveAccuralTargetSum] = useState(0);

  const editableCohortsFields = useEditableCohortFields(
    prtInfo?.activatedDate
  );

  const { accrualInfo } = prtInfo;

  const actualAccuralTarget = accrualInfo?.accruals?.filter(item => item.stepType === 'Intervention');

  let accuralTargetSum = 0;

  // calculate the sum of accural Targets for active cohorts, status = open.
  useEffect(() => {
    if(cohortData) {
      cohortData.reduce((acc, item) => {

        if(item.status === 'OPEN') {
          accuralTargetSum +=  item.accrualTarget;
          setActiveAccuralTargetSum(accuralTargetSum);
        }
        return null;
        
      }, 0)
    }
  }, [cohortData])

  const saveHandler = (cohortObj, setEditing) => {
    bindLogger(
      action.saveCohortArmData,
      context
    )(cohortObj).subscribe((resp) => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        setEditing(false);
        openSnackbar({
          message: "Cohort saved successfully.",
          variant: "success",
          name: "versions"
        });
      }
    });
  };
  const RenderEditRow = (row, setEditing) => {
    return (
      <EditArmCohort
        setEditing={setEditing}
        cohortData={cohortData}
        data={row}
        prtId={prtInfo.prtId}
        loadStatusRecords={loadStatusRecords}
        CanUserEditArmCohorts={CanUserEditArmCohorts}
        saveHandler={saveHandler}
        editableFields={editableCohortsFields}
        actualAccuralTarget={actualAccuralTarget[0]?.accrualTarget}
        accuralTargetSumActive={accuralTargetSumActive}
        accuralTargetSum={accuralTargetSum}
        setActiveAccuralTargetSum={setActiveAccuralTargetSum}
      />
    );
  };

  const handleHistory = (evt, row) => {
    onOpenModal({
      type: "CohortHistory",
      title: `Cohort Change History- Cohort ${row.cohortName}`,
      data: null
    });
    loadHistory(evt, row.pmcId);
  };

  return (
    <>
      <GridTable
        tag={`${TE.ID}cohorts${TE.TABLE}`}
        title="Cohorts"
        id="CohortsArmDataGrid"
        rows={cohortData}
        editable={canEditCohort}
        editMode={canEditCohort}
        rowEvents={[handleHistory]}
        columns={CohortsArmManagementColumns}
        user={GetUserFullName()}
        recordPerPage={5}
        enableToolbar
        onDataLoad={onLoad}
        highlightRowObject={highlightObj}
        onFilter={(y, field) => {
          setHighlighted(field);
        }}
        exportable={false}
        onRowClicked={rowClick}
        rowEditable={() => canEditCohort}
        allowAddRow={canAddArmsCohort && editableCohortsFields?.canAddCohort}
        renderEditRow={RenderEditRow}
        toPdf={false}
        addRowLabel="Cohort"
      />
    </>
  );
};
export default withAppContext(CohortsArmGrid);
